import { createApi } from '@reduxjs/toolkit/query/react';
import { Response } from '../../models/shared';
import { CreateCheckoutEventsDTO } from '../../models/checkout-event';
import baseQueryWithReauth from './base';

interface RecordCheckoutEventsArgs {
  businessId: string;
  eventId: string;
  body: CreateCheckoutEventsDTO;
}

const checkoutEventsApi = createApi({
  reducerPath: 'checkoutEventsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    // Medición del recorrido de compra. Es silenciosa (un error de medición no
    // se le muestra al comprador) y usa keepalive para que el último lote
    // llegue aunque la página se cierre o salte a la pasarela.
    recordCheckoutEvents: build.mutation<{ recorded: number }, RecordCheckoutEventsArgs>({
      query: ({ businessId, eventId, body }) => ({
        url: `businesses/${businessId}/events/${eventId}/checkout-events`,
        method: 'POST',
        body,
        keepalive: true,
      }),
      extraOptions: { silent: true },
      transformResponse: (response: Response<{ recorded: number }>) => response.data ?? { recorded: 0 },
    }),
  }),
});

export const { useRecordCheckoutEventsMutation } = checkoutEventsApi;
export { checkoutEventsApi };
